import { Navigate } from 'react-router-dom'

import { useAppSelector } from 'src/store/hooks'
import { selectUseQuizAnalyticsV2 } from 'src/v3/settings/settings.slice'
import QuizAnalyticsTabbedPage from './components/quiz-analytics-tabbed-page'
import QuizAnalyticsEmptyState from './components/quiz-analytics-empty-state'

let QuizAnalyticsOverviewContent = () => (
  <QuizAnalyticsTabbedPage>
    <QuizAnalyticsEmptyState
      title="Quiz analytics are coming soon"
      description="An overview of quiz performance across your organization will appear here."
    />
  </QuizAnalyticsTabbedPage>
)

let QuizAnalyticsOverviewPage = () => {
  let useQuizAnalyticsV2 = useAppSelector(selectUseQuizAnalyticsV2)

  if (!useQuizAnalyticsV2) {
    return <Navigate to="/manage" replace />
  }

  return <QuizAnalyticsOverviewContent />
}

export default QuizAnalyticsOverviewPage
